import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setProfile } from "../../../features/ProfileSlice";
import { createPartner } from "../../../services/Api/Module/Customer";

import PageLoader from "../../../components/loader/PageLoader";

const PartnerInvite = () => {
  const navigate = useNavigate();

  const { id } = useParams();

  const dispatch = useDispatch();
  const stateProfile = useSelector((state) => state.profile);

  const postCreatePartner = async (payload) => {
    let _return = {
      status: false,
      result: null,
    };

    try {
      const { data } = await createPartner({
        data: payload.data,
        partnerId: payload.partnerId,
      });
      if (data.resultCode === 20202) {
        const resData = data.body;
        // console.log("postCreatePartner resData >>", resData);

        _return.status = true;
        _return.result = resData;
      } else {
        console.error("ERR in createPartner:", data);
      }
    } catch (e) {
      console.log("ERR postCreatePartner >> ", e);
    }

    return _return;
  };

  useEffect(() => {
    // console.log("id >>>", id);
    // console.log("stateProfile >>>", stateProfile);

    if (typeof id === "undefined" || isNaN(Number(id))) {
      navigate("/");
    } else {
      if (stateProfile.id !== 0 && stateProfile.partnerId !== null) {
        postCreatePartner({
          data: {
            custId: stateProfile.id,
            lineUid: stateProfile.lineUid,
          },
          partnerId: stateProfile.partnerId,
        })
          .then((_rsData) => {
            // console.log("_rsData >>>", _rsData);

            if (_rsData.status === true) {
              setTimeout(() => {
                navigate("/member");
              }, 5000);
            } else {
              console.error("ERR in createPartner:", _rsData);
            }
          })
          .catch((error) => {
            console.error("ERR in createPartner:", error);
          });
      } else {
        dispatch(setProfile({ partnerId: Number(id) }));

        navigate("/");
      }
    }
  }, [id, stateProfile]);

  return <PageLoader />;
};

export default PartnerInvite;
